import $ from 'jquery';

// Adds a "Clear Date" button to the open jQuery UI datepicker of a field that has a date.
export const addClearDateButton = (inputField) => {
  if (inputField.value !== '') {
    setTimeout(() => {
      $('.ui-datepicker').addClass('ui-datepicker--with-clear-date-button');
      const $clearDateButton = $('<button/>', {
        text: 'Clear Date',
        class: 'ui-datepicker-clear-date',
        click: () => $.datepicker._clearDate(inputField),
      });
      $('.ui-datepicker').append($clearDateButton);
    }, 1);
  }
};
